import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Divider,
  IconButton,
  Stack,
  Box
} from "@mui/material";
import React, { useContext, useMemo, useState } from "react";
import { ProjectContext } from "../../contexts/ProjectContext";
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import { CommentsList } from "../Project/Comments/commentsList";
import {AddComment} from './addComment';

export const CommentsDialog = ({onOpen, onClose}) => {
  const [addCommentDialogOpen, setAddCommentDialogOpen] = useState(false);
  const { projectId, projectData } = useContext(ProjectContext);

  const handleDialogClose = (event, reason) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
      return;
    }
    onClose?.();
  };

  const paperProps = useMemo(() => ({
    sx: {
      borderRadius: 3,
      overflow: 'hidden',
      boxShadow: '0px 12px 40px rgba(15, 23, 42, 0.18)'
    }
  }), []);

  return (
    <div>
      <Dialog open={onOpen} maxWidth="sm" fullWidth onClose={handleDialogClose} PaperProps={paperProps}>
        <DialogTitle
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            py: 2.5,
            pr: 2,
            pl: 3
          }}
        >
          <Box>
            <Typography variant="h6" component="div">
              Comments
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Read existing discussion or add a new comment.
            </Typography>
          </Box>
          <IconButton
            aria-label="Close comments dialog"
            onClick={onClose}
            size="small"
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent
          dividers
          sx={{
            px: { xs: 2.5, sm: 3 },
            py: { xs: 2.5, sm: 3 },
            bgcolor: 'background.default'
          }}
        >
          <Stack spacing={2.5}>
            {projectData?.allowcomments && (
              <CommentsList projectId={projectId} />
            )}
            {!projectData?.allowcomments && (
              <Typography variant="body1">
                Comments are currently disabled for this project. To allow comments, please activate the feature in the project settings.
              </Typography>
            )}
          </Stack>
        </DialogContent>
        <Divider />
        <DialogActions
          sx={{
            px: { xs: 2.5, sm: 3 },
            py: { xs: 2.5, sm: 3 },
            bgcolor: 'background.paper',
            justifyContent: 'flex-end',
            gap: 1.5
          }}
        >
          <Button
            onClick={onClose}
            variant="outlined"
            color="inherit"
            startIcon={<CloseIcon fontSize="small" />}
          >
            Close
          </Button>
          <Button
            onClick={() => {setAddCommentDialogOpen(true);}}
            variant="contained"
            color="success"
            startIcon={<AddIcon />}
            disabled={!projectData?.allowcomments}
          >
            Write Comment
          </Button>
        </DialogActions>
      </Dialog>
      <AddComment onOpen={addCommentDialogOpen} onClose={()=> {setAddCommentDialogOpen(false)}} />
    </div>
  );
}